import { render, staticRenderFns } from "./SectionVideos.vue?vue&type=template&id=01621f9b&scoped=true"
import script from "./SectionVideos.vue?vue&type=script&lang=js"
export * from "./SectionVideos.vue?vue&type=script&lang=js"
import style0 from "./SectionVideos.vue?vue&type=style&index=0&id=01621f9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01621f9b",
  null
  
)

export default component.exports